module.exports = __webpack_public_path__ + "static/img/di_bg.ac5196f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/train/di_bg.png
// module id = +1Ty
// module chunks = 1